import { Layers } from 'lucide-react';
import TemplateGallery from '../components/templates/TemplateGallery';

export default function TemplatesPage() {
  return (
    <div className="h-full overflow-y-auto">
      <div className="max-w-6xl mx-auto px-6 py-8 space-y-6">
        <div className="space-y-1">
          <h1 className="text-xl font-semibold text-zinc-100 flex items-center gap-2">
            <Layers size={20} className="text-blue-400" />
            Templates
          </h1>
          <p className="text-sm text-zinc-500">
            Reusable design templates with dynamic field mappings for bulk generation
          </p>
        </div>

        <TemplateGallery />
      </div>
    </div>
  );
}
